import React from 'react'
import { serviceData } from '../../utils/constants';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const ServicePage = (props) => {
    const { selectedLanguage } = props
    const history = useHistory()
    const handleNavigation = (path) => {
        history.push(path);
    };
    return (
        <div className='main'>
            <div className='service-page-container'>
                <div className="service-data-main" data-aos="fade-right"
                    data-aos-easing="ease-out-cubic"
                    data-aos-delay="100"
                    data-aos-offset="0"
                    data-aos-duration="1500">
                    {serviceData?.map((v, i) => {
                        return (
                            <div key={i}>
                                <div className='box-main' onClick={() => handleNavigation(v?.path)}>
                                    <img src={v?.imageUrl} alt={v?.heading} />
                                </div>
                                <h3>{i === 0 ? selectedLanguage?.services_dental_diagnoses_and_gp_heading : i === 1 ? selectedLanguage?.services_aesthetic_dentistry_heading : i === 2 ? selectedLanguage?.services_endodontic_dentistry_heading : i === 3 ? selectedLanguage?.services_oral_surgery : i === 4 ? selectedLanguage?.orthodontic_dentistry_heading : i == 5 ? selectedLanguage?.prosthodontic_dentistry_heading : i === 6 ? selectedLanguage?.periodontal_dentistry_heading : i === 7 ? selectedLanguage?.services_dental_implants_heading : i == 8 ? selectedLanguage?.services_perdodontic_dentistry_heading : null}</h3>
                                <p>{i === 0 ? selectedLanguage?.diagnoes_paragraoh : i === 1 ? selectedLanguage?.aesthetic_dentistry_paragraph : i === 2 ? selectedLanguage?.endodontic_paragraph : i === 3 ? selectedLanguage?.oral_surgery_paragraph : i === 4 ? selectedLanguage?.orthodontic_dentistry_paragraph : i == 5 ? selectedLanguage?.prosthodontic_dentistry_paragraph : i === 6 ? selectedLanguage?.periodontal_dentistry_paragraph : i === 7 ? selectedLanguage?.dental_implants_paragraph : i == 8 ? selectedLanguage?.perdodontic_dentistry_paragraph : null}</p>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default ServicePage